module.exports = __webpack_public_path__ + "img/4sd.1d6bb61a.svg";